// Which person a member record is, for the sidebar sections that have to tell
// "the same person, refreshed" apart from "someone else".
//
// `_id`, NEVER `pid`. A pid is a per-family small integer, and pid 1 is the
// proband of every family, so it cannot say whether two records are the same
// person. A member added in this session has no `_id` until the first save
// echoes one back, but its `uid` is minted as the ObjectId hex that becomes
// that `_id` (mintObjectIdHex in pedigree/saveReconciliation.js), so falling
// back to it keeps the identity stable across the save. The G-number is the
// last resort for a record that carries neither; it is family-qualified, so it
// cannot collide across families either.
//
// Returns a string, or null when the record carries no identity at all.
export const memberIdentityOf = (member) => {
  if (!member) return null;
  const id =
    member._id ?? member.uid ?? member.familyMemberId ?? member.proBandId;
  return id == null || id === '' ? null : String(id);
};

/**
 * The identity of the row a per-person endpoint writes to, chosen the way
 * those endpoints choose it (POST /pedigree/person-tags, POST /genotypes/…/
 * variants/push): the proband's working record, which is the family root and
 * carries `proBandId`, when `isProband`; otherwise the member with that
 * `familyMemberId`. Null when this family holds no such row.
 */
export const endpointTargetIdentity = (
  records,
  { isProband, familyMemberId }
) => {
  if (!Array.isArray(records)) return null;
  const row = records.find((m) =>
    isProband
      ? !!m?.proBandId
      : familyMemberId != null && m?.familyMemberId === familyMemberId
  );
  return memberIdentityOf(row);
};
